import {Blockquote} from 'tiptap-extensions'
export default class CommentBlock extends Blockquote {
	get name() {
        return 'commentBlock'
    }
	get schema() {
	   return {
		 content: 'block*',
		 group: 'block',
		 defining: true,
		 draggable: false,
		 parseDOM: [
		   { tag: 'code' },
		 ],
		 toDOM: () => ['code', ['div', 0], ['div',
		 {
			 'class': 'delete-button',
			 'onclick': 'this.parentNode.remove()'
		 },]],
	   }
	 }
};
